(function() {
    'use strict';

    /**
     * Service for managing local users.
     */

    angular
        .module("pwc.pouch.user")
        .service("LocalUsers", LocalUsers);

    LocalUsers.$inject = ['$window', 'pouchDB', 'lodash', '$log', '$q', 'Utils', 'Rollbar'];

    function LocalUsers($window, pouchDB, lodash, $log, $q, Utils, Rollbar, UserService){

        /* jshint validthis: true */
        var self = this;

        // this will be the local pouch for storing all PWC users info
        // necessary for offline account management and offline login
        self.db = null;

        initialize();

        /**
         * Begin methods
         */

        // Constructor / Initialization
        function initialize(){

            // iOS is limited to 50, don't need more for this database though
            var opts = {
                "size": 50,
                "auto_compaction": true
            };

            // initialize the local user pouch
            self.db = pouchDB('pwc_users', opts);

            $log.debug('Initialized LocalUsers pouch db.', self.db);
        }

        /**
         * Retrieve all known users.
         */
        function all(){
            $log.debug('Fetching all local users...');

            return self.db.allDocs({
                include_docs: true,
                attachments: false
            }).then(function(users){
                $log.debug('Local Users:', users);
                return users;
            });
        }

        function findByName(name){
            var userName = name;

            $log.debug('Finding by name...', userName);

            return all()
                    .then(function(response){
                        var users = lodash.pluck(response.rows, 'doc');

                        return lodash.findWhere(users, {"name": userName});
                    }).then(function(user){
                        $log.debug('Find result:', user);

                       if (! user){
                           return $q.reject('User not found by name.');
                       }

                       return user;
                    });
        }

        /**
         * Add user to local users pouch.
         */
        function addUser(doc){
            $log.debug('LocalUsers:addUser', doc);
            return self.db.put(doc);
        }

        /**
         * @param userName
         * @return Promise
         */
        function setActiveUser(userName){

            $log.debug('Setting Active User...', userName);

            return localActiveUser()
                .then(function(user){
                    $log.debug('Current Active User:', user);

                    if (userName !== lodash.get(user, 'userName')){
                        $log.debug('We have a new active user!', userName);

                        return storeActiveUser(userName, lodash.get(user, '_rev'));

                    } else {
                        $log.debug('Active user is the same. Nothing to update.');
                    }
                }).catch(function(err){
                    // no active user
                    $log.warn('No Active User yet. Storing user...', err.message);
                    return storeActiveUser(userName, null);
                });
        }

        /**
         * Saves the active username so we can attempt to see if there's an active session when user returns without them having to supply a username.
         * Use "local" docs. See https://pouchdb.com/guides/local-documents.html
         * @param userName
         * @param revision
         * @return Promise
         */
        function storeActiveUser(userName, revision){
            var doc = {
                "_id": "_local/active",
                "userName": userName,
                "_rev": revision
            };

            if (! revision){
                delete doc['_rev'];
            }

            $log.debug('Storing User on LocalUsers:', doc);

            return self.db.put(doc);
        }

        function activeUser(){

            $log.debug('LocalUsers:activeUser');

            return activeUserName()
                .then(findByName)
                .then(function(user){
                    $log.debug("localUsers:activeUser:", user);

                    bootIntercom(user);
                    bootRollbar(user);

                    return user;
                });
        }

        function localActiveUser(){

            $log.debug('Looking for local active user...');

            return self.db.get('_local/active').then(function(user){
                $log.debug('Active User:', user);
                return user;
            });
        }

        function activeUserName(){
            return localActiveUser().then(function(user){
                $log.debug('LocalUsers:activeUserName', user);
                return lodash.get(user, 'userName');
            });
        }

        function getDatabase(){
            return self.db;
        }

        function bootRollbar(user){
            var rollbarUser = {
                payload: {
                    person: {
                        id: user.name,
                        username: user.name,
                        email: lodash.get(user, 'metadata.email'),
                        name: lodash.get(user, 'metadata.billing.card.name', user.name),
                        plan: lodash.get(user, 'metadata.plan.label')
                    }
                }
            };

            $log.debug('Configuring Rollbar...', rollbarUser);

            Rollbar.Rollbar.configure(rollbarUser);

            return user;
        }

        function bootIntercom(user){

            $log.debug('Booting Intercom for', user);

            var userEmail = lodash.get(user, 'metadata.email');

            var intercomConfig = {
                app_id: "c5mj6vtf",
                name: lodash.get(user, 'metadata.billing.card.name', user.name),
                user_id: userEmail,
                email: userEmail,
                account: user.name,
                plan: lodash.get(user, 'metadata.plan.label'),
                coupon: lodash.get(user, 'metadata.coupon'),
                giftcode: lodash.get(user, 'metadata.giftcode'),
                created_at: lodash.get(user, 'metadata.billing.created') // Signup date as a Unix timestamp
            };

            $log.debug('Intercom config', intercomConfig);

            $window.Intercom('boot', intercomConfig);

            return user;
        }

        /**
         * Wipes local database.
         * @return Promise
         */
        function destroy(){

            if (self.db){
                $log.debug('Destroying LocalUsers db...');
                return self.db.destroy().catch(function(err){
                    $log.error('Error destroying LocalUsers', err);
                });
            }

            return $q.when(false);
        }

        // exposed, public API
        return {
            initialize: initialize,
            getDatabase: getDatabase,
            all: all,
            findByName: findByName,
            addUser: addUser,
            activeUser: activeUser,
            activeUserName: activeUserName,
            setActiveUser: setActiveUser,
            destroy: destroy
        };

    }

})();
